/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Embed_Captions_Upload_Failed_StatusInputs */

const en_embed_captions_upload_failed_status = /** @type {(inputs: Embed_Captions_Upload_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Upload Failed: ${i?.error}`)
};

const fr_embed_captions_upload_failed_status = /** @type {(inputs: Embed_Captions_Upload_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Televersement echoue : ${i?.error}`)
};

const de_embed_captions_upload_failed_status = /** @type {(inputs: Embed_Captions_Upload_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Upload fehlgeschlagen: ${i?.error}`)
};

const it_embed_captions_upload_failed_status = /** @type {(inputs: Embed_Captions_Upload_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caricamento non riuscito: ${i?.error}`)
};

const ru_embed_captions_upload_failed_status = /** @type {(inputs: Embed_Captions_Upload_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Загрузка не удалась: ${i?.error}`)
};

const es_embed_captions_upload_failed_status = /** @type {(inputs: Embed_Captions_Upload_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error de carga: ${i?.error}`)
};

const zh_cn2_embed_captions_upload_failed_status = /** @type {(inputs: Embed_Captions_Upload_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`上传失败：${i?.error}`)
};

const ja_embed_captions_upload_failed_status = /** @type {(inputs: Embed_Captions_Upload_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アップロードに失敗しました: ${i?.error}`)
};

const hi_embed_captions_upload_failed_status = /** @type {(inputs: Embed_Captions_Upload_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अपलोड विफल: ${i?.error}`)
};

const pt_pt2_embed_captions_upload_failed_status = /** @type {(inputs: Embed_Captions_Upload_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha no upload: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Upload Failed: {error}" |
*
* @param {Embed_Captions_Upload_Failed_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_upload_failed_status = /** @type {((inputs: Embed_Captions_Upload_Failed_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Upload_Failed_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_upload_failed_status(inputs)
	if (locale === "de") return de_embed_captions_upload_failed_status(inputs)
	if (locale === "it") return it_embed_captions_upload_failed_status(inputs)
	if (locale === "ru") return ru_embed_captions_upload_failed_status(inputs)
	if (locale === "es") return es_embed_captions_upload_failed_status(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_upload_failed_status(inputs)
	if (locale === "ja") return ja_embed_captions_upload_failed_status(inputs)
	if (locale === "hi") return hi_embed_captions_upload_failed_status(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_upload_failed_status(inputs)
	return en_embed_captions_upload_failed_status(inputs)
});